window.setFinancingReservationFormFinancialProduct = function(type, uuid) {
    let reservationFormLW = eval(
        document.getElementById('financing-reservation-form').dataset.livewire
    );

    reservationFormLW.setFinancialProduct(type, uuid);
    // reservationFormLW.emit('domUpdated');
};

window.clearFinancingReservationFormFinancialProduct = function() {
    let reservationFormLW = eval(
        document.getElementById('financing-reservation-form').dataset.livewire
    );

    reservationFormLW.clearFinancialProduct();
};

document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('financingReservationSaved', event => {
        let successMessage = document.getElementById('financing-reservation-form').dataset.success || 'Reservation successful!';
        let flashMessageHtml =
            '<div class="alert alert-success" onclick="$(this).remove();event.preventDefault();">' +
            '<img src="/images/icons/ico-alert-success.svg" alt="" class="icon icon--w32 flex-shrink-0">' +
            '<div>' +
            '<h5 class="h5 alert__title">' + successMessage + '</h5>' +
            '</div>' +
            '</div>';
        $('main').append(flashMessageHtml);
        $('#modalWantIt').modal('hide');
    });
});
